/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInConnectResponseCheckpointType = typeof LinkedInConnectResponseCheckpointType[keyof typeof LinkedInConnectResponseCheckpointType] | null;


export const LinkedInConnectResponseCheckpointType = {
  '2FA': '2FA',
  OTP: 'OTP',
  CAPTCHA: 'CAPTCHA',
  IN_APP_VALIDATION: 'IN_APP_VALIDATION',
  PHONE_REGISTER: 'PHONE_REGISTER',
} as const;
